"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _joinRaceButton = _interopRequireDefault(require("./join-race-button"));
var _specialQueriesModal = _interopRequireWildcard(require("./specialQueriesModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *******************************************************************************
// Display the possible races
// *******************************************************************************

class EligibleRace extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_askQueries", () => {
      if (this.props.eligibility.race.specialRefs.some(special => _specialQueriesModal.specialRefsWithQueries.includes(special)) && this.props.eligibility.eligibilityStatus.entryID) return true;
      return false;
    });
  }
  render() {
    const eligibility = this.props.eligibility;
    const race = eligibility.race;
    const firstRace = this.props.firstRace;
    return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, firstRace ? race.competition.competitionName : ''), /*#__PURE__*/_react.default.createElement("td", null, firstRace ? race.raceName : '', !firstRace || !race.competitionDivision.isRestricted ? '' : /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "danger",
      style: {
        marginLeft: 5
      },
      size: "sm",
      title: race.competitionDivision.restriction || 'The organiser has flagged this division as restricted entry.  Please make sure that you are eligible to enter.'
    }, "View Restriction")), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(race.competitionDay.dayDate, 'ddd DD MMM')), /*#__PURE__*/_react.default.createElement("td", {
      className: eligibility.eligibilityStatus.textClass
    }, eligibility.eligibilityStatus.text), /*#__PURE__*/_react.default.createElement("td", {
      className: "pull-sm-right"
    }, /*#__PURE__*/_react.default.createElement(_joinRaceButton.default, {
      raceEligibility: eligibility,
      classDivisionID: this.props.classDivisionID,
      cseBibID: this.props.cseBibID,
      setEntryError: this.props.setEntryError
    }), !this._askQueries() ? null : /*#__PURE__*/_react.default.createElement(_specialQueriesModal.default, {
      entryID: eligibility.eligibilityStatus.entryID,
      race: race
    })));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}
//
// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(EligibleRace, "partialQueries", {
  Race: _mergeBqlQueries(_mergeBqlQueries({
    id: true,
    raceName: true,
    competition: {
      id: true,
      competitionName: true
    },
    competitionDay: {
      dayDate: true
    },
    competitionDivision: {
      isRestricted: true,
      restriction: true
    },
    specialRefs: true
  }, _joinRaceButton.default.partialQueries.Race), _specialQueriesModal.default.partialQueries.Race),
  EligibilityStatus: _mergeBqlQueries({
    text: true,
    textClass: true,
    entryID: true
  }, _joinRaceButton.default.partialQueries.EligibilityStatus)
});
var _default = exports.default = EligibleRace;